module.exports = __webpack_public_path__ + "media/audio5.1d7683e9.mp3";